<template>
  <div class="home">
    <AnimatedHero>
      <div class="hero-video-container">
        <video autoplay loop muted playsinline class="hero-video">
          <source src="/Video_HomePage.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="container hero-content">
        <div class="hero-text">
          <h1>The Innovation is our path. Your success is our purpose.</h1>
          <p>We help businesses transform their ideas into powerful digital experiences with cutting-edge technology and creative solutions.</p>
          <div class="cta-buttons">
            <router-link to="/contact" class="btn btn-primary">Get Started</router-link>
            <a href="#services" class="btn btn-outline framed-button">Our Services</a>
          </div>
        </div>
      </div>
    </AnimatedHero>

    <!-- Services Section -->
    <section id="services" class="services">
      <div class="container">
        <div class="services-grid">
          <div class="service-card custom-software">
            <div class="service-header">
              <div class="service-icon service-icon--custom">
                <font-awesome-icon :icon="['fas', 'laptop-code']" class="service-fa-icon" />
              </div>
              <h3 style="color: #0e3273;">Custom Software</h3>
            </div>
            <div class="service-content">
              <p style="color: #0B3479;">Tailor-made software solutions designed to meet your specific business requirements and challenges.</p>
            </div>
          </div>
          <div class="service-card">
            <div class="service-header">
              <div class="service-icon service-icon--mobile">
                <font-awesome-icon :icon="['fas', 'mobile-alt']" class="service-fa-icon" />
              </div>
              <h3>Mobile Apps</h3>
            </div>
            <div class="service-content">
              <p style="color: #0B3479;">Engaging mobile applications for iOS and Android platforms that deliver seamless user experiences.</p>
            </div>
          </div>
          <div class="service-card">
            <div class="service-header">
              <div class="service-icon service-icon--cloud">
                <font-awesome-icon :icon="['fas', 'cloud']" class="service-fa-icon" />
              </div>
              <h3>Cloud Solutions</h3>
            </div>
            <div class="service-content">
              <p style="color: #0B3479;">Scalable cloud infrastructure and services to optimize your business operations and reduce costs.</p>
            </div>
          </div>
          <div class="service-card">
            <div class="service-header">
              <div class="service-icon service-icon--cyber">
                <font-awesome-icon :icon="['fas', 'shield-alt']" class="service-fa-icon" />
              </div>
              <h3>Cybersecurity</h3>
            </div>
            <div class="service-content">
              <p style="color: #0B3479;">Comprehensive security solutions to protect your digital assets and ensure data privacy.</p>
            </div>
          </div>
          <div class="service-card">
            <div class="service-header">
              <div class="service-icon service-icon--analytics">
                <font-awesome-icon :icon="['fas', 'chart-line']" class="service-fa-icon" />
              </div>
              <h3>Data Analytics</h3>
            </div>
            <div class="service-content">
              <p style="color: #0B3479;">Actionable insights from your data to drive informed business decisions and growth.</p>
            </div>
          </div>
          <div class="service-card">
            <div class="service-header">
              <div class="service-icon service-icon--consulting">
                <font-awesome-icon :icon="['fas', 'user-gear']" class="service-fa-icon" />
              </div>
              <h3>IT Consulting</h3>
            </div>
            <div class="service-content">
              <p style="color: #0B3479;">Expert guidance to help you navigate the complex world of technology and digital transformation.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="cta-social">
          <div class="social-title">Follow us!</div>
          <div class="social-icons">
            <a href="#" aria-label="LinkedIn" class="social-icon" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'linkedin-in']" />
            </a>
          </div>
        </div>
        <div class="cta-content">
          <h2 class="expertise-title" style="color: #ffffff; margin-bottom: 2rem; position: relative; display: inline-block;">Ready to transform your business?</h2>
          <router-link to="/contact" class="btn btn-white">Let's connect</router-link>
          <div class="cta-footer">
            Copyright &copy; 2025 Advanced Innovatics Solutions | All rights reserved.
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AnimatedHero from '@/components/AnimatedHero.vue'

export default {
  name: 'HomeView',
  components: {
    AnimatedHero
  }
}
</script>

<style scoped>
/* CTA Section */
.cta {
  background: linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%);
  color: white;
  padding: 4rem 0;
}

.cta .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.cta .cta-social {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
  text-align: left;
}

.cta .cta-social .social-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #ffffff;
  margin: 0;
}

.cta .cta-social .social-icons {
  display: flex;
  gap: 1rem;
}

.cta .cta-social .social-icon {
  width: 64px;
  height: 64px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 1.5rem;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.cta .cta-social .social-icon:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-content {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.expertise-title {
  color: #0e3273;
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0 0 1.5rem 0;
  position: relative;
  display: inline-block;
}

.expertise-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 50px;
  height: 4px;
  background: #4361ee;
  border-radius: 2px;
}

.cta .expertise-title {
  color: #ffffff;
  margin-bottom: 1.5rem;
}

.cta .expertise-title::after {
  display: none;
}

.cta .btn-white {
  background: transparent;
  color: #ffffff;
  border: 3px solid #ffffff;
  border-radius: 50px;
  padding: 0.75rem 2.5rem;
  font-weight: 700;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
  display: inline-block;
  letter-spacing: 0.5px;
}

.cta .btn-white:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-footer {
  flex: 0 0 100%;
  text-align: left;
  margin-top: 2rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  padding-top: 0;
  border: none;
}

/* Responsive */
@media (max-width: 768px) {
  .cta .container {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
  
  .cta .cta-content {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  
  .cta .cta-footer {
    text-align: left;
    margin-top: 1rem;
    width: 100%;
  }
}

.home {
  display: flex;
  flex-direction: column;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
  padding: 6rem 2rem;
  color: white;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hero-video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.hero-layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
  width: 100%;
}

.hero-text {
  max-width: 600px;
  text-align: left;
  margin: 0;
  padding: 0;
  background: transparent;
  backdrop-filter: none;
  border: none;
  box-shadow: none;
}

/* Video styles moved to .hero-video-container */

h1 {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: #f0f0f0;
}

p {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  color: #f0f0f0;
  line-height: 1.6;
  max-width: 100%;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  margin-top: 2rem;
}

.btn {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  border: 2px solid transparent;
}

.btn-primary {
  background-color: #4361ee;
  color: white;
  border: 2px solid #4361ee;
}

.btn-primary:hover {
  background-color: #3a56d4;
  border-color: #3a56d4;
}

.btn-outline {
  background-color: transparent;
  color: white;
  border: 2px solid white;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.btn-outline:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.framed-button {
  position: relative;
  padding: 0.75rem 1.5rem;
}

.framed-button::before,
.framed-button::after {
  content: '';
  position: absolute;
  background: transparent;
  z-index: -1;
  transition: all 0.3s ease;
}

.framed-button::before {
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  border-radius: 6px;
}

.framed-button:hover::before {
  border-color: white;
  top: -8px;
  left: -8px;
  right: -8px;
  bottom: -8px;
}

/* Responsive styles */
@media (max-width: 1200px) {
  .hero-content {
    padding: 4rem 2rem;
    min-height: 80vh;
    justify-content: center;
  }
  
  .hero-text {
    text-align: center;
    max-width: 100%;
    margin: 0 auto;
  }
  
  .cta-buttons {
    justify-content: center;
  }
}

@media (max-width: 992px) {
  .hero-content h1 {
    font-size: 2.75rem;
    line-height: 1.2;
  }
  
  .hero-content p {
    font-size: 1.2rem;
  }
}

@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2.25rem;
    margin-bottom: 1.25rem;
  }
  
  .hero-content p {
    font-size: 1.1rem;
    margin-bottom: 1.75rem;
  }
  
  .cta-buttons {
    flex-direction: row;
    justify-content: flex-start;
    gap: 1rem;
  }
  
  .btn {
    width: 100%;
    max-width: 280px;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding: 2rem 1rem;
  }
  
  .hero-text {
    padding: 0;
  }
  
  .hero-content h1 {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.75rem;
  }
  
  .hero-content p {
    font-size: 1rem;
  }
  
  .btn {
    padding: 0.65rem 1.25rem;
    font-size: 0.95rem;
  }
}

/* Services Section */
.services {
  padding: 6rem 0;
  background-color: #f8f9fa;
  position: relative;
  overflow: hidden;
}

.services::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(to bottom, #ffffff, rgba(248, 249, 250, 0));
  z-index: 1;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  position: relative;
  z-index: 2;
}

.service-card {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4361ee, #3a0ca3);
  transition: all 0.4s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(67, 97, 238, 0.15);
  border-color: rgba(67, 97, 238, 0.2);
}

.service-card:hover::before {
  height: 6px;
}

.service-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 2;
}

.service-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.25rem;
  background-color: #f0f4ff;
  box-shadow: 0 4px 12px rgba(13, 50, 115, 0.1);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transform-origin: center;
  transform: scale(0.9);
  opacity: 0.9;
}

.service-card:hover .service-icon {
  transform: scale(1.05);
  background-color: transparent;
  opacity: 1;
  box-shadow: 0 6px 20px rgba(67, 97, 238, 0.15);
}

.service-fa-icon {
  font-size: 1.8rem;
  color: #0e3273;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transform: scale(0.9);
}

.service-card:hover .service-fa-icon {
  transform: scale(1.1);
  color: #4361ee;
}

.service-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #0e3273 !important;  
  font-weight: 700;
  transition: all 0.3s ease;
}

.service-content {
  flex: 1;
  position: relative;
  z-index: 2;
}

.service-content p {
  margin: 0;
  color: #4a5568;
  line-height: 1.8;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 15px;
  border-left: 3px solid #e9ecef;
}

.service-card:hover p {
  color: #2d3748;
  border-left-color: #4361ee;
  padding-left: 20px;
}

/* Custom Software Card */
.service-card.custom-software::before {
  background: linear-gradient(90deg, #4361ee, #3a0ca3);
}

.service-card.custom-software .service-fa-icon {
  background: linear-gradient(135deg, #4361ee, #3a0ca3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.service-card.custom-software .service-icon {
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
}

/* Add subtle floating elements in the background */
.service-card::after {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(67, 97, 238, 0.05) 0%, rgba(67, 97, 238, 0) 70%);
  border-radius: 50%;
  top: -100px;
  right: -100px;
  opacity: 0;
  transition: all 0.6s ease;
}

.service-card:hover::after {
  opacity: 1;
  transform: scale(1.5);
}

</style>